import { copyTextToClipboard } from "lib/clipboard"
import { useNotifications } from "lib/NotificationsProvider"
import { useCallback } from "react"

export default function useClipboard() {
  const { addNotification } = useNotifications()

  const handleCopy = useCallback(async (text: string, message?: string) => {
    await copyTextToClipboard(text)
    addNotification({ variant: 'notice', message: message || 'Copied to clipboard' })
  }, [addNotification])

  return { copyToClipboard: handleCopy }
}
